
export default class {
  static get() {
    try {
      const unique_values = [
        window.navigator.hardwareConcurrency, // OS cores
        window.navigator.platform,
        window.navigator.appVersion,
        window.navigator.vendor,
        window.navigator.userAgent,
        window.navigator.maxTouchPoints,
        new Date().getTimezoneOffset()
      ];

      let navobj = {};
      for (let i in window.navigator) navobj[i] = window.navigator[i];
      unique_values.push(JSON.stringify(navobj));

      if (performance.memory) {
        unique_values.push(performance.memory.jsHeapSizeLimit);
        unique_values.push(performance.memory.jsHeapSizeLimit);
      }
      let fingerprint = Number.MAX_SAFE_INTEGER / 2; // A lucky number as fingerprint base ;)
      function fp_add_val(uval) {
        if (uval <= 128) uval += Math.pow(uval, 3+Math.round(uval/128*3));
        uval = uval % 2 === 0 ? uval : -uval;
        fingerprint += uval;
      }

      for (let v = 0; v < unique_values.length; v++) {
        if (typeof unique_values[v] === 'string') {
          for (let c = 0; c < unique_values[v].length; c++) {
            fp_add_val(unique_values[v].charCodeAt(c));
          }
        } else {
          fp_add_val(unique_values[v]);
        }
      }

      return fingerprint;
    } catch (e) {
      console.error(e);
    }
  }
}
